export default __webpack_public_path__ + "static/media/3.6f33bab6.jpg";